
import{ Component , Input , Output, EventEmitter,ElementRef,HostListener,ViewChild } from '@angular/core'
@Component({
    selector: 'ion-auto-complete',
    templateUrl: './autocomplete.component.html',
  
  
})
export class AutoCompleteComponent   {
    @Input() set autocompleteModel(autocompleteModel: any[]) {
        this.autocompleteModelData=autocompleteModel;
    
    }
    autocompleteModelData :any[]=[];
    @Input() inputPlaceholder : string='';
    searchText : string ='';
    ItemNotFound : boolean= false;
    @Input() inputId : string =''
    @Input() inputName : string =''
   
   filteredautocompleteItems : any[]=[];
   @Output() SelectedZipcode = new EventEmitter<any>();
   
   @Input()
   set setSelectedZipcode(setSelectedZipcode: any) {
    this.filteredautocompleteItems=[];
    this.searchText=setSelectedZipcode;
   }

  
   
    
    constructor(private el: ElementRef) { }
   

    @Output() public onFocusOut  = new EventEmitter();
  
    @HostListener('document:click', ['$event.target'])
    public onClick(target: any) {
    
        const clickedInside = this.el.nativeElement.contains(target);
       
        if (!clickedInside) {
          this.onFocusOut.emit(target);
          this.filteredautocompleteItems=[];
        }
        else{
            this.inputfocus();
        }
    }

    inputfocus() {
        if(this.searchText == ""){
            this.filteredautocompleteItems=this.autocompleteModelData;
        }
        else{
            this.search();
        } 
    }

   
    search() : void{
        if(this.searchText == ""){
            this.filteredautocompleteItems=[];
            return;
        }
     this.filteredautocompleteItems = this.autocompleteModelData.filter(item => item.includes(this.searchText.toUpperCase()))
     this.ItemNotFound = this.filteredautocompleteItems.length>0 ?false : true;
    if(this.ItemNotFound){      
        this.SelectedZipcode.emit(this.searchText);
      
    }
     
       
    }

    selectItem(selectedItem : any) : void{ 
        this.filteredautocompleteItems=[];
        this.searchText=selectedItem;
         this.SelectedZipcode.emit(selectedItem);      
    }
   
}





// WEBPACK FOOTER //
// ./src/app/lib/autocomplete/autocomplete.component.ts